module.exports = __webpack_public_path__ + "img/bak.b98b7a77.svg";